<template>
  <div>
    <PayabliEmbeddedCreditCard
      :api-token="apiToken"
      :entry-point-name="entryPointName"
      :amount="amount"
      :selected-payment-option="selectedPaymentOption"
      :credit-card-form-valid="creditCardFormValid"
      :temporary-method-token="createTemporaryPaymentMethod"
      :loading="isProcessingPayment"
      :authenticated="true"
      :on-pay="onPay"
      :load-script="loadScript"
      :re-initialize-payabli-component="reInitializePayabliComponent"
    />
  </div>
</template>

<script setup lang="ts">
import PayabliEmbeddedCreditCard from "./PayabliEmbeddedCreditCard.vue";
import { usePayabliEmbeddedComponent } from "../composables/usePayabliEmbeddedComponent";
import type { PaymentMethod, SelectablePaymentOptions } from "@/types";

interface Props {
  apiToken: string;
  entryPointName: string;
  amount: number;
  paymentOption: "one-time" | "installments";
  customerNumber: string;
  isProcessingPayment: boolean;
  makePayment: (
    referenceType: PaymentMethod,
    referenceId: string,
    paymentOption: SelectablePaymentOptions
  ) => Promise<boolean>;
}

const props = defineProps<Props>();

// Now we can safely initialize Payabli because this component only renders when we have valid values
const {
  creditCardFormValid,
  createTemporaryPaymentMethod,
  onPay,
  loadScript,
  reInitializePayabliComponent,
  selectedPaymentOption,
} = usePayabliEmbeddedComponent(
  props.apiToken,
  props.entryPointName,
  props.makePayment,
  props.customerNumber,
  "card" // Always start with card
);
</script>
